import axios from 'axios';

export function setupAxiosInterceptors() {
  // Cookies HttpOnly enviados automaticamente pelo browser em todas as requisições same-origin
  axios.defaults.withCredentials = true;

  // Limpar interceptors anteriores (evita duplicação em chamadas repetidas)
  axios.interceptors.request.handlers = [];
  axios.interceptors.response.handlers = [];

  // Sessão expirada (401) — limpar estado local e redirecionar ao login
  // Exceção: endpoints de auth (login, validate, 2fa) — erro 401 é esperado/tratado localmente
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 && !error.config?.url?.includes('/api/auth/')) {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('sessionExpiry');
        window.location.href = '/';
        return Promise.reject(error);
      }

      // Erro 503 com flag maintenance — sistema em manutenção
      if (error.response?.status === 503 && error.response?.data?.maintenance) {
        window.dispatchEvent(new CustomEvent('app:maintenance', {
          detail: { message: error.response.data.message, isNetworkError: false }
        }));
        return Promise.reject(error);
      }

      // Erro de rede (backend inacessível)
      if (!error.response && error.code !== 'ERR_CANCELED') {
        window.dispatchEvent(new CustomEvent('app:maintenance', {
          detail: { message: null, isNetworkError: true }
        }));
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );
}
